import React from 'react';
import { TourDetailPage } from '../components/TourDetailPage';
import { worldwideTours } from '../data/tours';

export const ShanghaiCruisePage = () => {
  const tour = worldwideTours.find(t => t.id === 'shanghai-cruise');
  return <TourDetailPage tour={tour} />;
};
